import { RouteObject } from 'react-router-dom';

import { CompanyHealthActivity } from './CompanyHealthActivity/CompanyHealthActivity';
import { Layout } from './Layout';
import { NoCompanyActivity } from './NoCompanyActivity/NoCompanyActivity';



export const root: RouteObject = {

  path: 'sentiment',
  element: (
    <Layout />
  ),
  children: [
    {
      path: '',
      index: true,
      element: <NoCompanyActivity />
    },
    {
      path: 'health/:companyId',
      element: <CompanyHealthActivity />
    }
  ]

};
